<h2 mat-dialog-title>{{ 'app.billing.licences.assign.title' | translate }}</h2>

<mat-dialog-content>
    @if (pendingCancellationAt(); as endsAt) {
    <p class="av-billing-warning mb-3">
        {{ 'app.billing.licences.assign.pending_warning' | translate: { date: endsAt | date: 'mediumDate' } }}
    </p>
    }

    @if (isEmpty()) {
    <p class="av-billing-note mb-0">{{ 'app.billing.licences.assign.empty' | translate }}</p>
    } @else {
    <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'app.billing.licences.assign.user' | translate }}</mat-label>
        <mat-select [value]="selectedUserId()" (valueChange)="selectUser($event)">
            @for (user of data.users; track user.id) {
            <mat-option [value]="user.id">
                <span>{{ user.name || user.displayName }}</span>
                <span class="av-billing-note ms-2">{{ user.email || user.userPrincipalName }}</span>
            </mat-option>
            }
        </mat-select>
    </mat-form-field>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button (click)="close()">{{ 'shared.general.buttons.cancel' | translate }}</button>
    <button mat-flat-button color="primary" [disabled]="isConfirmDisabled()" (click)="confirm()">
        {{ 'app.billing.licences.assign.confirm' | translate }}
    </button>
</mat-dialog-actions>
